export default function validateFile(
  type: string,
  size: number,
  name: string,
  maxFileSize?: number,
) {
  if (size > 1024 * 1024 * (maxFileSize || 30)) {
    throw new Error('파일 용량은 최대 30MB입니다.');
  }
  if (name.length > 100) {
    throw new Error('파일명은 100자 이내여야 합니다.');
  }
}
